import React from 'react';
import { Navbar, Footer } from '../components';
import Seo from '../components/Seo';
import Features from '../components/features/Features';

function Solution() {
    return (
        <React.Fragment>
            <Seo
                title="Features"
                description="Everything WayaQuick does for your business: payment links, invoices, subscriptions, a secure checkout with five payment methods, instant or scheduled settlement, payouts, refunds, team roles and developer tools."
            />
            <Navbar />
            <Features />
            <Footer />
        </React.Fragment>
    );
}

export default Solution;